import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateAgoPipe } from './pipes/date-ago.pipe';
import { FilterPipe } from './pipes/filter.pipe';
import { SortPipe } from './pipes/sort.pipe';
import { PopOverComponent } from './components/pop-over/pop-over.component';



@NgModule({
  declarations: [DateAgoPipe, FilterPipe, SortPipe, PopOverComponent],
  imports: [
    CommonModule,
  ],
  exports: [DateAgoPipe, FilterPipe, SortPipe, PopOverComponent]
})
export class SharedModule { }
